var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export var RECENT_PROJECTS_KEY = 'ccw_recent_projects';
export var RECENT_PROJECTS_LIMIT = 5;
function isRecentProjectItem(item) {
    return (!!item &&
        typeof item === 'object' &&
        typeof item.id === 'string' &&
        typeof item.title === 'string');
}
export function loadRecentProjects() {
    if (!process.client)
        return [];
    try {
        var raw = localStorage.getItem(RECENT_PROJECTS_KEY);
        if (!raw)
            return [];
        var parsed = JSON.parse(raw);
        if (!Array.isArray(parsed))
            return [];
        return parsed.filter(isRecentProjectItem).slice(0, RECENT_PROJECTS_LIMIT);
    }
    catch (e) {
        return [];
    }
}
/** 新しい案件を先頭に追加（同一 id は除外）。最大 RECENT_PROJECTS_LIMIT 件。 */
export function pushRecentProject(project) {
    if (!process.client || !project.id)
        return loadRecentProjects();
    var title = (project.title && String(project.title).trim()) || project.id;
    var next = __spreadArrays([
        { id: project.id, title: title }
    ], loadRecentProjects().filter(function (item) { return item.id !== project.id; })).slice(0, RECENT_PROJECTS_LIMIT);
    try {
        localStorage.setItem(RECENT_PROJECTS_KEY, JSON.stringify(next));
    }
    catch (e) {
        // localStorage 不可時は無視
    }
    return next;
}
